import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { media, SelectionCard } from "@helium10/re-ui-components";
import { Elements } from "@stripe/react-stripe-js";
import { useCallback } from "react";
import styled from "styled-components";
import { Image } from "../../common/components/Image";
import { useTranslation } from "../../i18n/useTranslation";
import alipayImage from "../../static/images/alipay.svg";
import alipayMobImage from "../../static/images/alipay-mob.svg";
import creditCardImage from "../../static/images/credit-card.svg";
import creditCardMobImage from "../../static/images/credit-card-mob.svg";
import { PaymentAlipay } from "./components/PaymentAlipay";
import { PaymentCard } from "./components/PaymentCard";
import { Title } from "./Styles";
export const Checkout = ({ isCardAvailable, isModal, data, actions, modalText, disclaimer, securePayment, recaptchaV2, useAlipay, useCard, }) => {
    const { t } = useTranslation();
    const { paymentMode, paymentMethods, stripe, paymentModeController, paymentEditingController } = data || {};
    const handleAlipayMethod = useCallback(() => {
        paymentModeController?.set("alipay");
    }, [paymentModeController]);
    const handleCardMethod = useCallback(() => {
        paymentModeController?.set("card");
    }, [paymentModeController]);
    const handleEditCard = useCallback(() => {
        paymentModeController?.set("card");
        paymentEditingController?.set(true);
    }, [paymentModeController, paymentEditingController]);
    const isModalCardAvailable = isModal && isCardAvailable;
    const filteredPaymentMethods = paymentMethods?.filter((method) => method !== "apple_pay");
    const isMultiplePaymentMethods = !isModalCardAvailable && (filteredPaymentMethods?.length || 0) > 1;
    const isAlipay = paymentMode === "alipay";
    const isCard = paymentMode === "card";
    return (_jsx(Elements, { stripe: stripe, children: _jsxs(_Fragment, { children: [isMultiplePaymentMethods && (_jsxs(_Fragment, { children: [_jsx(Title, { children: t("checkout.method.selectTitle") }), _jsxs(SelectMethod, { children: [_jsx(Option, { "$isModal": isModal, active: isAlipay, onClick: handleAlipayMethod, children: _jsx(Image, { image: alipayImage, smallImage: alipayMobImage }) }), _jsxs(Option, { "$isModal": isModal, active: isCard, onClick: handleCardMethod, children: [t("checkout.method.secureCreditCard"), _jsx(Image, { image: creditCardImage, smallImage: creditCardMobImage })] })] })] })), isAlipay && (_jsx(PaymentAlipay, { useAlipay: useAlipay, recaptchaV2: recaptchaV2, disclaimer: disclaimer, actions: actions })), isCard && (_jsx(PaymentCard, { isModal: isModal, useCard: useCard, modalText: modalText, recaptchaV2: recaptchaV2, handleEditCard: handleEditCard, securePayment: securePayment, disclaimer: disclaimer, actions: actions }))] }) }));
};
const SelectMethod = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
`;
const Option = styled(SelectionCard) `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  user-select: none;
  cursor: pointer;
  font-weight: 700;
  font-size: 12px;
  color: ${(p) => p.theme.systemColors.black};
  height: ${({ $isModal }) => ($isModal ? "72px" : "96px")};
  padding: 0;
  gap: 8px;

  ${media.laptopBefore} {
    min-width: 100%;
  }

  ${media.desktopBefore} {
    flex: 1;
  }

  ${media.desktop} {
    width: 160px;
  }
`;
